import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import './sales.css'

export default class SaleGoalBar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sum: 0
        };

        this.loadGoal = this.loadGoal.bind(this);
    }

    componentDidMount() {
        this.loadGoal();
    }

    loadGoal() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Sale/GetGoal', {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ sum: result.sum });
                }).catch((err) => console.log(err));
            }
        });
    }
    getPercent(sum) {
        return sum / 540000;
    }

    render() {
        return (
            <div style={{
                "background": "rgb(40, 198, 106)",
                "background": "linear-gradient(90deg, rgba(40, 198, 106, 0.6166841736694677) 0%, rgba(255, 255, 255, 1) " + this.getPercent(this.state.sum) + "%)"}} className="sale-goal-bar">
                Продаж с победой c 01.01.2023 на {this.state.sum.toLocaleString()}
            </div>
        );
    }
}
